import { render, staticRenderFns } from "./FileAgent.vue?vue&type=template&id=00f60cad"
import script from "./FileAgent.vue?vue&type=script&lang=js"
export * from "./FileAgent.vue?vue&type=script&lang=js"
import style0 from "./FileAgent.vue?vue&type=style&index=0&id=00f60cad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports